// extracted by mini-css-extract-plugin
module.exports = {"giftAmount":"ApplyGiftAmount_giftAmount__3wYIj"};